import { GetterTree } from 'vuex'
import RootState from '@vue-storefront/core/types/RootState'
import { getAppliedGiftCards, isGiftCardProduct } from '../helpers'
import { GRAND_TOTAL_SEGMENT_CODE } from '../constants'

const getters: GetterTree<{}, RootState> = {
  appliedGiftCards: (state, getters, rootState, rootGetters) => getAppliedGiftCards(rootGetters['cart/getTotals']),
  isGiftCardCart: (state, getters, rootState, rootGetters) => (rootGetters['cart/getCartItems'] || []).some(isGiftCardProduct),
  isFullyCovered: (state, getters, rootState, rootGetters) => {
    const grandTotal = (rootGetters['cart/getTotals'] || []).find(total => total.code === GRAND_TOTAL_SEGMENT_CODE)

    return getters.appliedGiftCards.codes.length > 0 && Boolean(grandTotal) && Number(grandTotal.value) === 0
  }
}

export default getters
